module.exports = __webpack_public_path__ + "files/091c4f27ad9782f8a6e50a90055554ce.svg";